import http from './httpRequest.js'

export const uploadApi = {
    // 初始化上传
    initUpload(request) {
        return http({
            url: '/file/upload/init',
            method: 'post',
            data: request
        }).then(response => response)
    },

    // 上传分片
    uploadChunk(formData) {
        return http({
            url: '/file/upload/chunk',
            method: 'post',
            data: formData
        })
    },

    // 完成上传
    completeUpload(request) {
        console.log('completeUpload')
        return http({
            url: '/file/upload/complete',
            method: 'post',
            data: request
        }).then(response => response)
    },

    // 获取已上传的分片
    getUploadedChunks(uploadId) {
        return http({
            url: '/file/upload/chunks/'+uploadId,
            method: 'get',
        }).then(response => response)
    },

    // 取消上传
    cancelUpload(request) {
        return http({
            url: '/file/upload/cancel',
            method: 'post',
            data: request
        })
    }
}